// extracted by mini-css-extract-plugin
export var arrow = "_3u-6";
export var changeItem = "_3u-3";
export var changesHeader = "_3u-1";
export var changesList = "_3u-2";
export var container = "_3u-0";
export var pathLabel = "_3u-4";
export var value = "_3u-7";
export var valuesContainer = "_3u-5";